import { useDispatch } from 'react-redux';
import { AppDispatch } from 'reduxStore/types';

export const useAppDispatch = () => useDispatch<AppDispatch>();
